import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "col-12" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = { class: "fluid grid" }
const _hoisted_4 = { class: "field col-12 xxl:col-4 align-self-end" }
const _hoisted_5 = { class: "flex" }
const _hoisted_6 = { class: "field col-12 xxl:col-4 align-self-end" }
const _hoisted_7 = { class: "flex" }
const _hoisted_8 = { class: "field col-12 xxl:col-4 align-self-end" }
const _hoisted_9 = { class: "flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h4", null, [
        _cache[6] || (_cache[6] = _createTextVNode(" Customer Details ", -1)),
        (_ctx.customerCompanyId != null && _ctx.isInternalUser)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              onClick: [
                _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.navigation.toCompanyDetailsScreen(_ctx.customerCompanyId)), ["exact"])),
                _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.navigation.toCompanyDetailsScreen(_ctx.customerCompanyId,true)), ["shift"]))
              ]
            }, [...(_cache[5] || (_cache[5] = [
              _createElementVNode("i", {
                class: "pi pi-external-link p-1",
                style: {"font-size":"1rem"}
              }, null, -1)
            ]))]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[7] || (_cache[7] = _createElementVNode("label", null, "Customer name", -1)),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_Multiselect, {
              options: _ctx.companyList,
              searchable: true,
              limit: 40,
              filter: true,
              class: "w-100pc",
              modelValue: _ctx.selectedCustomerCompanyId,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedCustomerCompanyId) = $event)),
              valueProp: "id",
              label: "nameAndId",
              "track-by": "nameAndId",
              placeholder: "Select Customer"
            }, null, 8, ["options", "modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _cache[8] || (_cache[8] = _createElementVNode("label", null, "Billing Customer (different company/address/contacts)", -1)),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_Multiselect, {
              options: _ctx.companyList,
              searchable: true,
              limit: 40,
              filter: true,
              class: "w-100pc",
              modelValue: _ctx.selectedBillingCustomerCompanyId,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedBillingCustomerCompanyId) = $event)),
              valueProp: "id",
              label: "nameAndId",
              "track-by": "nameAndId",
              placeholder: "Select Billing Company (if different company)"
            }, null, 8, ["options", "modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _cache[9] || (_cache[9] = _createElementVNode("label", null, "Billing Name (same company/address/contacts)", -1)),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_Multiselect, {
              options: _ctx.billingEntityList,
              searchable: true,
              limit: 40,
              filter: true,
              class: "w-100pc",
              modelValue: _ctx.selectedBillingEntityId,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedBillingEntityId) = $event)),
              valueProp: "billingEntityId",
              label: "billingEntityName",
              "track-by": "billingEntityName",
              noOptionsText: "(No alternate billing names have been entered for these companies)",
              placeholder: "Select Alternative Billing Name"
            }, null, 8, ["options", "modelValue"])
          ])
        ])
      ])
    ])
  ]))
}